import { render, staticRenderFns } from "./D3OrdinalAxis.vue?vue&type=template&id=233208d4&scoped=true"
import script from "./D3OrdinalAxis.vue?vue&type=script&lang=js"
export * from "./D3OrdinalAxis.vue?vue&type=script&lang=js"
import style0 from "./D3OrdinalAxis.vue?vue&type=style&index=0&id=233208d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233208d4",
  null
  
)

export default component.exports